<template>
    <svg viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.999999 0.500001L7 6.5L1 12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
